import WishListService from "../Dashboard/wishListService";

class MostPurchased {
    constructor() {
        this.wishListService = new WishListService();

        $("button.addToWishlist").on('click', (event) => {
            this.wishListService.toggleWishList($(event.currentTarget));
        });

    }
}

$(document).ready(function () {
    new MostPurchased();
});
